'use client';

import * as React from 'react';

import { Eye, EyeOff } from 'lucide-react';
import { InputPrefixSuffixCds } from '@/components/cds/input-prefix-suffix-cds';

/**
 * InputPasswordCds component
 * @description
 * A password input field with a toggle button to show/hide the password.
 * @param {React.ComponentProps<'input'>} props
 * @param {React.RefObject<HTMLInputElement>} ref
 * @returns {React.ReactElement}
 * @example
 * ```tsx
 * <InputPasswordCds />
 * ```
 * @example
 * ```tsx
 *  <InputPasswordCds className="text-sm" placeholder="Enter your password" required />
 * ```
 */
const InputPasswordCds = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ ...props }, ref) => {
    const [showPassword, setShowPassword] = React.useState(false);
    const togglePasswordVisibility = () => setShowPassword(!showPassword);

    return (
      <InputPrefixSuffixCds
        {...props}
        type={showPassword ? 'text' : 'password'}
        ref={ref}
        suffixIcon={showPassword ? EyeOff : Eye}
        suffixClassName="size-[1rem] right-[0.65rem]"
        onSuffixClick={togglePasswordVisibility}
        className="pr-[2rem]"
      />
    );
  }
);
InputPasswordCds.displayName = 'InputPasswordCds';

export { InputPasswordCds };
